import "./TopBar.scss";
import Logo from "../../../img/agroweb-logo.png";
import { useGlobalLocation } from "../../../shared/LocationContext.js";
import { id2 } from "../../../shared/utillity.js";
import { NavLink } from "react-router-dom";

export default function TopBar() {
  const { pathPart } = useGlobalLocation();

  return (
    <div className={`topBar ${id2(pathPart)}`}>
      <NavLink to="/" className="topBar-logo">
        <img src={Logo} alt="logo" />
      </NavLink>
      <a href="mailto:info@agroweb.rs" className="topBar__link" rel="noopener noreferrer">
        info@agroweb.rs
      </a>
      <div className="topBar__link">
        <a href="https://www.instagram.com/agroweb.portal/" target="_blank" rel="noopener noreferrer">
          <img src="/img/icons/inst.png" alt="Agroweb.rs - instagram" />
        </a>
        <a href="https://www.facebook.com/agroweb.portal" target="_blank" rel="noopener noreferrer">
          <img src="/img/icons/facebook.png" alt="Agroweb.rs - facebook" />
        </a>
      </div>
    </div>
  );
}
